import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useNavigate } from "react-router-dom";

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export const siTabs = [
  {
    label: "ACT Sports Integrity",
    isHeader: true,
  },
  {
    label: "Built for compliance. Powered by Integrity.",
    slug: "built-for-compliance"
  },
  {
    label: "Geolocation & Anti-Fraud detection",
    slug: "geolocation-anti-fraud"
  },
  {
    label: "Integration and Scalability",
    slug: "integration-scalability"
  },
  {
    label: "Sports Integrity Monitoring System",
    slug: "monitoring"
  },
  {
    label: "Dashboard Insights",
    slug: "dashboard-insights"
  },
  {
    label: "Integration",
    slug: "si-Integration"
  },
  {
    label: "Troubleshooting",
    slug: "troubleshooting"
  },
];

export function getIndexFromSlug(slug) {
  const contentTabs = siTabs.filter((t) => !t.isHeader);
  const index = contentTabs.findIndex((t) => t.slug === slug);
  return index >= 0 ? index : 0;
}

export function getSlugFromIndex(index) {
  const contentTabs = siTabs.filter((t) => !t.isHeader);
  return contentTabs[index]?.slug ?? contentTabs[0].slug;
}

export default function SiTabs({ value, onChange }) {
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    const headersBefore = siTabs
      .slice(0, newValue)
      .filter((t) => t.isHeader).length;
    const actualContentIndex = newValue - headersBefore;

    const slug = getSlugFromIndex(actualContentIndex);
    navigate(`/sports-integrity/${slug}`);

    onChange(actualContentIndex);
  };

  let visualIndex = 0;
  let clickableCount = 0;

  for (let i = 0; i < siTabs.length; i++) {
    if (!siTabs[i].isHeader) {
      if (clickableCount === value) {
        visualIndex = i;
        break;
      }
      clickableCount++;
    }
  }

  return (
    <Tabs
      orientation="vertical"
      variant="scrollable"
      value={visualIndex}
      onChange={handleChange}
      sx={{
        width: "100%",
        "& .MuiTab-root": {
          textTransform: "none",
          fontWeight: "400",
          fontSize: "14px",
          minHeight: 40,
          alignItems: "flex-start",
          textAlign: "left",
          borderBottom: "0.1rem #d8d8d8 solid",
          "&:hover": {
            backgroundColor: " #e3e3e3",
          },
        },
        "& .Mui-selected": {
          color: "#e54f9c !important",
          backgroundColor: "#fcd4e9",
        },
        "& .MuiTabs-indicator": {
          width: 0,
        },
      }}
    >
      {siTabs.map((tab, index) => (
        <Tab
          key={`${tab.label}-${index}`}
          label={tab.label}
          disabled={tab.isHeader}
          {...a11yProps(index)}
          sx={{
            ...(tab.isHeader && {
              opacity: "1 !important",
              color: "#fff !important",
              fontWeight: "bold !important",
              fontSize: "12px",
              backgroundColor: "#000000",
              cursor: "default",
              pointerEvents: "none",
              letterSpacing: "0.05rem",
              marginTop: "0",
            }),
          }}
        />
      ))}
    </Tabs>
  );
}
